import React, { useEffect, useRef } from 'react'
import { GoogleMap } from '@react-google-maps/api'
import { CSSObject } from 'styled-components'
import { PinMarker } from './PinMarker'
import { EnrollmentLocation } from '@utils/getNearbyEnrollmentLocations'

export const Map: React.FC<{
  center?: google.maps.LatLng | google.maps.LatLngLiteral | null
  locationMarkers?: Array<EnrollmentLocation>
  containerStyle?: CSSObject
  full?: boolean
  zoom?: number
  selectedLocation?: string
}> = ({
  center,
  locationMarkers,
  containerStyle,
  full,
  zoom,
  selectedLocation,
}) => {
  const map = useRef<GoogleMap | null>(null)
  const dimensions = useRef<{ width: number; height: number }>({
    width: 300,
    height: 500,
  })

  /**
   * Dynamically adjust map dimensions to parent container when props.full == true
   */
  useEffect(() => {
    if (full && map?.current?.mapRef?.parentElement) {
      const { width, height } =
        map?.current?.mapRef?.parentElement?.getBoundingClientRect()
      dimensions.current = {
        width,
        height,
      }
    }
  }, [map, full])

  const handleMarkerClick = (address: string) => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${encodeURI(
        address
      )}`,
      '_blank'
    )
  }

  return (
    <GoogleMap
      ref={map}
      mapContainerStyle={{
        width: full ? undefined : `${dimensions.current.width}px`,
        height: `${dimensions.current.height}px`,
        ...containerStyle,
      }}
      center={center ? center : undefined}
      zoom={zoom ? zoom : 11}
      id="google-map"
    >
      {locationMarkers?.map((location, i) => {
        return (
          <>
            <PinMarker
              key={location.locationCode}
              markerNumber={(i + 1).toString()}
              location={location}
              onClick={() => handleMarkerClick(location.address)}
              isSelectedLocation={location.locationCode === selectedLocation}
            />
          </>
        )
      })}
    </GoogleMap>
  )
}

Map.displayName = 'Map'
